// Youssef Selkani
// 2019

import React, { Component } from 'react'
import {
  Progress,
  Button,
  Message,
  Placeholder,
  Segment,
  Grid,
  Container,
  Loader,
  Icon
} from 'semantic-ui-react'
import fire, { storage } from '../config/Fire'
import Img from 'react-image'
import '../App.css'
import { CompactPicker } from 'react-color'
import FontPicker from 'font-picker-react'
import { InputFile } from 'semantic-ui-react-input-file'

const ImgLoader = (
  <Placeholder fluid style={{ height: '50px', width: '50px' }}>
    <Placeholder.Image />
  </Placeholder>
)

export default class AppStyle extends Component {
  constructor (props) {
    super(props)
    this.state = {
      icon: null,
      progress: 0,
      uploaded: false,
      loading: true,
      activeFontFamily: 'Open Sans',
      splashurl: null,
      iconurl: null
    }
    this.handleUpload = this.handleUpload.bind(this)
    this.handleUploadSplash = this.handleUploadSplash.bind(this)
  }

  componentDidMount () {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        const { currentUser } = fire.auth()
        let userUnderscore = currentUser.email.replace(/\./g, '_')
        this.setState({ userUnderscore: userUnderscore })
        storage
          .ref(`/icons/${userUnderscore}`)
          .child('appicon')
          .getDownloadURL()
          .then((iconurl) => {
            this.setState({ iconurl })
          })
          .catch((error) => {
            console.log(error)
          })
        storage
          .ref(`/splash-screens/${userUnderscore}`)
          .child('splash')
          .getDownloadURL()
          .then((splashurl) => {
            this.setState({ splashurl })
          })
          .catch((error) => {
            console.log(error)
          })
        this.userData()
      } else {
        this.props.history.push('/')
      }
    })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          if (obj.fontFamily === null) {
            this.setState({ fontFamily: 'Open Sans' })
          }
          this.setState({
            accent: obj.accent,
            accent2: obj.accent2,
            bgcolor: obj.bgcolor,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error |  code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  handleFileChange = (e) => {
    if (e.target.files[0]) {
      const icon = e.target.files[0]
      this.setState(() => ({ icon, selected: true }))
    }
  }
  handleFileChange2 = (e) => {
    if (e.target.files[0]) {
      const splashScreen = e.target.files[0]
      this.setState(() => ({ splashScreen, selected2: true }))
    }
  }

  handleUpload = () => {
    const { currentUser } = fire.auth()
    let userUnderscore = currentUser.email.replace(/\./g, '_')
    this.setState({ uploading: true })
    const { icon } = this.state
    const uploadTask = storage.ref(`/icons/${userUnderscore}/appicon`).put(icon)
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        this.setState({ progress })
      },
      (error) => {
        console.log(error)
      },
      () => {
        storage
          .ref(`/icons/${userUnderscore}`)
          .child('appicon')
          .getDownloadURL()
          .then((iconurl) => {
            this.setState({
              iconurl,
              uploaded: true,
              uploading: false,
              selected: false,
              success: true
            })
            this.edit()
          })
      }
    )
  }

  handleUploadSplash = () => {
    const { currentUser } = fire.auth()
    let userUnderscore = currentUser.email.replace(/\./g, '_')
    this.setState({ uploading: true })
    const { splashScreen } = this.state
    const uploadTask = storage.ref(`/splash-screens/${userUnderscore}/splash`).put(splashScreen)
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        this.setState({ progress })
      },
      (error) => {
        console.log(error)
      },
      () => {
        storage
          .ref(`/splash-screens/${userUnderscore}`)
          .child('splash')
          .getDownloadURL()
          .then((splashurl) => {
            this.setState({
              splashurl,
              uploaded2: true,
              uploading: false,
              selected2: false,
              success: true
            })
            this.edit()
          })
      }
    )
  }

  handleColorPicker = (color) => {
    this.setState({ accent: color.hex, edit: true })
  }
  handleColorPicker2 = (color) => {
    this.setState({ accent2: color.hex, edit: true })
  }
  handleBgColor = (color) => {
    this.setState({ bgcolor: color.hex, edit: true })
  }

  edit = (e) => {
    // e.preventDefault()
    this.setState({ loading: true, error: null })
    fetch('https://murkstomstag.herokuapp.com/api/v1/style', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        colors: {
          accent: this.state.accent,
          accent2: this.state.accent2,
          bgcolor: this.state.bgcolor
        },
        style: {
          fontFamily: this.state.fontFamily
        },
        icon: this.state.iconurl,
        splashScreen: this.state.splashurl
      })
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ loading: false, saved: true, saving: false })
          setTimeout(
            function () {
              this.setState({
                saved: false
              })
            }.bind(this),
            2000
          )
        } else {
          this.setState({ error: 'Error ' + response.status, loading: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  render () {
    let {
      iconurl,
      selected,
      progress,
      error,
      uploaded,
      edit,
      loading,
      saved,
      accent,
      accent2,
      bgcolor,
      selected2,
      uploading,
      uploaded2,
      splashurl,
      fontFamily
    } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>Style</h2>
          <Button
            loading={loading}
            disabled={!edit}
            error={error}
            content={!saved ? 'Save' : 'Saved successfully!'}
            onClick={this.edit}
            style={{
              backgroundColor: !saved ? '#000' : '#f7d170',
              color: !saved ? '#fff' : '#000'
            }}
          />
          {error && (
            <div className='mtbs error'>
              <p>Error: {String(this.state.error)}</p>
            </div>
          )}
        </div>

        <Grid centered stackable verticalAlign='top' fluid>
          <Grid.Column width='16'>
            <Grid reversed='mobile' stackable fluid centered>
              <Grid.Column width='8' fluid>
                <Segment basic>
                  <h3>Featured color</h3>
                  <p className='mts'>Main color of the app</p>
                  {!loading ? (
                    <CompactPicker
                      triangle='hide'
                      width='100%'
                      id='picker'
                      color={accent}
                      onChangeComplete={this.handleColorPicker}
                    />
                  ) : (
                    <Placeholder fluid style={{ height: '100px', width: '100%' }}>
                      <Placeholder.Image />
                    </Placeholder>
                  )}
                </Segment>
              </Grid.Column>
              <Grid.Column width='8'>
                <Segment basic>
                  <h3>Secondary color</h3>
                  <p className='mts'>Borders and shadow color</p>
                  {!loading ? (
                    <CompactPicker
                      triangle='hide'
                      width='100%'
                      id='picker2'
                      color={accent2}
                      onChangeComplete={this.handleColorPicker2}
                    />
                  ) : (
                    <Placeholder fluid style={{ height: '100px', width: '100%' }}>
                      <Placeholder.Image />
                    </Placeholder>
                  )}
                </Segment>
              </Grid.Column>
              <Grid.Column width='5' />
            </Grid>
          </Grid.Column>
          <Grid.Column width='16'>
            <div className='screen-card'>
                <Segment padded basic>
                  <Grid columns='2' verticalAlign='middle' stackable>
                    <Grid.Column>
              {uploading &&
                <div className='mbs'>
                  <Progress fluid percent={progress} active color='black' size='small' />
                  Uploading...
                </div> }
                      <h3 size='small'>App Icon</h3>
                      <p>Android: (512x512px)</p>
                      <p>iOS: (1024x1024px)</p>
                      {uploaded && (
                        <div className='mbs'>
                          <Message compact>Uploaded successfully!</Message>
                        </div>
                      )}
                      {iconurl && (
                        <Img
                          className='dropshadow'
                          decode={false}
                          src={iconurl}
                          loader={ImgLoader}
                          style={{
                            width: '50px',
                            height: '50px',
                            resizeMode: 'contain'
                          }}
                          alt='logo-app'
                        />
                      )}
                      <div className='mtbs'>
                        <InputFile
                          button='compact basic'
                          input={{
                            id: 'input-control-id',
                            accept: 'image/x-png, image/jpeg',

                            onChange: this.handleFileChange
                          }}
                        />
                      </div>
                      <Button
                        compact
                        disabled={!selected}
                        onClick={this.handleUpload}
                        style={{
                          backgroundColor: '#f7d170',
                          color: '#000'
                        }}>
                        <i class='ui upload icon' />
                        Upload
                      </Button>
                    </Grid.Column>
                    <Grid.Column>
                      <h3 size='small'>Splash screen</h3>
                      <p>(1080x1920px)</p>
                      {uploaded2 && (
                        <div className='mbs'>
                          <Message compact>Uploaded successfully!</Message>
                        </div>
                      )}

                      {splashurl && !loading && (
                        <Img
                          className='dropshadow'
                          decode={false}
                          src={splashurl}
                          loader={<Loader active inline size='small' />}
                          style={{
                            width: '100px',
                            resizeMode: 'contain'
                          }}
                          alt='splash-screen'
                        />
                      )}
                      <div className='mtbs'>
                        <InputFile
                          button='compact basic'
                          input={{
                            accept: 'image/x-png, image/jpeg',
                            id: 'input-control-id2',
                            onChange: this.handleFileChange2
                          }}
                        />
                      </div>
                      <Button
                        compact
                        disabled={!selected2}
                        onClick={this.handleUploadSplash}
                        style={{
                          backgroundColor: '#f7d170',
                          color: '#000'
                        }}>
                        <i class='ui upload icon' />
                        Upload
                      </Button>
                    </Grid.Column>
                  </Grid>
                </Segment>

            </div>
          </Grid.Column>
          <Grid.Column width='16'>
            <div className='dashboard'>
              <Segment padded='very' basic>
                <Grid columns='2' verticalAlign='middle' stackable>
                  <Grid.Column>
                    <h3>Font family</h3>
                    {!loading ? (
                      <FontPicker
                        apiKey='AIzaSyD0-iRs2qmr1TfsDIpZ5n4h_EBorc2mcIA'
                        activeFontFamily={fontFamily}
                        onChange={(nextFont) =>
                          this.setState({
                            fontFamily: nextFont.family,
                            edit: true
                          })
                        }
                      />
                    ) : (
                      <Loader active inline size='small' />
                    )}
                  </Grid.Column>
                  <Grid.Column>
                    <h3>Preview</h3>
                    <p className='apply-font'>
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                      ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis
                      parturient montes.
                    </p>
                  </Grid.Column>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}
